import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

type PriceAlertMetadata = {
  title: string;
  description: string;
  ogAlt: string;
};

export const PRICE_ALERT_METADATA = {
  vinyl: {
    en: {
      title: "Vinyl Price Alerts Across Stores and Marketplaces",
      description:
        "Compare vinyl prices from record shops and marketplaces. Start free price-drop alerts with no signup.",
      ogAlt: "Vinyl price alerts across record shops and marketplaces on Garimpa.Club",
    },
    pt: {
      title: "Alertas de preço de vinil em várias lojas",
      description:
        "Compare preços de vinil em lojas de discos e marketplaces. Ative grátis alertas de queda de preço, sem cadastro.",
      ogAlt: "Alertas de preço de vinil em lojas de discos e marketplaces no Garimpa.Club",
    },
    es: {
      title: "Alertas de precios de vinilos en varias tiendas",
      description:
        "Compara precios de vinilos en tiendas de discos y marketplaces. Activa gratis alertas de bajadas de precio, sin registrarte.",
      ogAlt: "Alertas de precios de vinilos en tiendas de discos y marketplaces en Garimpa.Club",
    },
  },
  cd: {
    en: {
      title: "CD Price Alerts Across Stores and Marketplaces",
      description:
        "Compare CD prices from record shops and marketplaces. Start free price-drop alerts with no signup.",
      ogAlt: "CD price alerts across record shops and marketplaces on Garimpa.Club",
    },
    pt: {
      title: "Alertas de preço de CD em várias lojas",
      description:
        "Compare preços de CD em lojas de discos e marketplaces. Ative grátis alertas de queda de preço, sem cadastro.",
      ogAlt: "Alertas de preço de CD em lojas de discos e marketplaces no Garimpa.Club",
    },
    es: {
      title: "Alertas de precios de CD en varias tiendas",
      description:
        "Compara precios de CD en tiendas de discos y marketplaces. Activa gratis alertas de bajadas de precio, sin registrarte.",
      ogAlt: "Alertas de precios de CD en tiendas de discos y marketplaces en Garimpa.Club",
    },
  },
} satisfies Record<"vinyl" | "cd", Record<ViewerLocale, PriceAlertMetadata>>;
